// extracted by mini-css-extract-plugin
export var container = "_5j-1";
export var editor = "_5j-2";
export var resizable = "_5j-3";
export var wrapper = "_5j-0";